import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import dayjs from "dayjs";
export const EventLink = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "CafeSignUp":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/event/user/signup/detail", saveFetch: { fetchUrl: "/api/cafe/event/user/signup/edit" } },
        dataResultName: "detail_result",
        dataName: "UserInfo",
        useDefaultId: false,
        defaultMode: "edit",
        editCheck: true,
        useList: false,
        dataCols: {
          cafe_name_locale: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          cafe_name: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          signup_range: {
            labelClassName: dc.strongLabelClassName,
            inputType: "datetimeRange",
            fieldIds: ["event_start", "event_end"],
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          save_check: { ...dc.use, inputClassName: "ml-2", labelClassName: dc.strongLabelClassName },
          user_nick: { ...dc.input, minLength: 3, maxLength: 100, showCount: true, changePass: true },
          user_desc: { ...dc.textAreaDefault, maxLength: 3000, showCount: true },
        },
        listColLinkField: ["event_uuid"],
        base64Field: ["event_uuid"],
        dataReloadButton: false,
        saveDetail: "signin_detail",
        saveOkDesc: "signin_ok",
        saveCheck: (save_cols, obj) => {
          // Debug(save_cols, obj);
          const check_value = obj["save_check"];
          if (!check_value) {
            return { field: "save_check", message: "save_check_ok", value: 0, label: "save_check" };
          } else {
            return undefined;
          }
        },
        saveButtonTitle: "signup_label",
        saveButtonIcon: { iconName: "UserCheck", iconType: "" },
        // undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    case "RoasterSignUp":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/event/user/signup/detail", saveFetch: { fetchUrl: "/api/roaster/event/user/signup/edit" } },
        dataResultName: "detail_result",
        dataName: "UserInfo",
        useDefaultId: false,
        defaultMode: "edit",
        editCheck: true,
        useList: false,
        dataCols: {
          roaster_name_locale: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          roaster_name: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          signup_range: {
            labelClassName: dc.strongLabelClassName,
            inputType: "datetimeRange",
            fieldIds: ["event_start", "event_end"],
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          save_check: { ...dc.use, inputClassName: "ml-2", labelClassName: dc.strongLabelClassName },
          user_nick: { ...dc.input, minLength: 3, maxLength: 100, showCount: true, changePass: true },
          user_desc: { ...dc.textAreaDefault, maxLength: 3000, showCount: true },
        },
        listColLinkField: ["event_uuid"],
        base64Field: ["event_uuid"],
        dataReloadButton: false,
        saveDetail: "signin_detail",
        saveOkDesc: "signin_ok",
        saveCheck: (save_cols, obj) => {
          // Debug(save_cols, obj);
          const check_value = obj["save_check"];
          if (!check_value) {
            return { field: "save_check", message: "save_check_ok", value: 0, label: "save_check" };
          } else {
            return undefined;
          }
        },
        saveButtonTitle: "signup_label",
        saveButtonIcon: { iconName: "UserCheck", iconType: "" },
        // undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    default:
      return undefined;
  }
};
